﻿export interface ICenterAddress {
    id: number,
    isDeleted: boolean,
    typeId: number,
    typeName: string,
    label: string,
    addressLine1: string,
    addressLine2: string,
    addressLine3: string,
    city: string,
    stateId: number,
    state: string,
    stateAbbreviation: string,
    postalCode: string,
    centerId: number,
    note: string,
    firstName: string,
    lastName: string,
    shipToPhoneNumber: string
}

export interface ICenterAddressContract {
    id?: number,
    typeId: number,
    addressLine1: string,
    addressLine2: string,
    addressLine3: string,
    city: string,
    stateId: number,
    postalCode: string,
    centerId: number,
    note: string,
    label: string,
    firstName: string,
    lastName: string,
    shipToPhoneNumber: string
}
